import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button, Container, Alert, Row, Col } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Video = () => {
    const [clientKey, setClientKey] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null); // New state for end date
    const [count, setCount] = useState(null);
    const [error, setError] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!clientKey || !startDate || !endDate) {
            alert("Please fill in all fields.");
            return;
        }

        const formatDateToUTC = (date) => {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        };

        const startDateUTC = formatDateToUTC(startDate).toISOString();
        const endDateUTC = formatDateToUTC(endDate).toISOString(); // Use the selected end date

        try {
          const response = await axios.post(
              'https://d8b5x27ag9.execute-api.ap-south-1.amazonaws.com/default/eSign_Count_Api/query', 
              {
                  clientKey,
                  startDate: startDateUTC,
                  endDate: endDateUTC,
              },
              {
                  headers: {
                      'x-api-key': 'lgFJ3r2OhtZ7TwA7IfST1zVBsLtw3Sn55trDgak1' // Add your header key here
                  }
              }
          );

          setCount(response.data.count);
          setError(null);
      } catch (error) {
            console.error("Error querying count:", error);
            setError("Failed to get the count. Check the console for details.");
        }
    };

    return (
        <Container className="p-4 my-5 border rounded shadow-sm">
            <h2 className="mb-4 text-center">Query eSign Count</h2>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <Form.Group controlId="clientKey" className="mb-3">
                            <Form.Label>Client Key</Form.Label>
                            <Form.Control
                                type="text"
                                value={clientKey}
                                onChange={(e) => setClientKey(e.target.value)}
                                placeholder="Enter client key"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="startDate" className="mb-3">
                            <Form.Label>Start Date</Form.Label>
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                className="form-control"
                                placeholderText="Select start date"
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group controlId="endDate" className="mb-3">
                            <Form.Label>End Date</Form.Label>
                            <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                className="form-control"
                                placeholderText="Select end date"
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Button variant="primary" type="submit" className="w-100 mt-3">
                    Get Count
                </Button>
            </Form>
            {count !== null && (
                <Alert variant="success" className="mt-4">
                    Count of Records: {count}
                </Alert>
            )}
            {error && (
                <Alert variant="danger" className="mt-4">
                    {error}
                </Alert>
            )}
        </Container>
    );
};

export default Video;
